import React from 'react'
import { useWordPressPage } from '../uses/useWordPressPage'
import WordPressPage from '../components/WordPressPage'
import Layout from '../components/Layout'
import Blocks from '../components/Blocks'

const path = require('path')

const SLUG = path.basename(__filename).split('.')[0]

export default () => {
  const page = useWordPressPage(SLUG)
  return (
    <Layout slug={SLUG}>
      <WordPressPage page={page} />
      <div id="page-content" />
      <div className="page-content text-content">
        <div
          className="headlines"
          dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
        />
        <div
          className="event-media media-text"
          dangerouslySetInnerHTML={{ __html: page.content }}
        />

        <Blocks page={page} />
      </div>
    </Layout>
  )
}
